import requests from "../util";
const { request } = requests;

const getWalletAccountDetails = () => {
  return request({
    url: "/api/v1/organization/getWalletAccountDetails",
    method: "get",
  });
};
const initiateCheckoutToFundWallet = (payload) => {
  return request({
    url: "/api/v1/batch/initiateCheckoutToFundWallet",
    method: "post",
    body: payload,
  });
};
const payOrderFromBatch = (payload) => {
  return request({
    url: "/api/v1/batch/deductPaymentFromWalletForBatch",
    method: "post",
    body: payload,
  });
};

const getPurchaseHistory = (pageNum, pageSize) =>{
  let params = { pageNum, pageSize };
  return request({
    url: "/api/v1/organization/getPurchaseHistory",
    method: "get",
    params
  })
}

const getWalletTransactions = (pageNum, pageSize) =>{
  let params = { pageNum, pageSize };
  return request({
    url: "/api/v1/organization/getWalletTransactions",
    method: "get",
    params
  })
}


const userWalletApi = {
  getWalletAccountDetails,
  initiateCheckoutToFundWallet,
  payOrderFromBatch,
  getPurchaseHistory,
  getWalletTransactions
};

export default userWalletApi;
